<template>
    <div>
        <toggle
            :checked="useCustomTemplate"
            @change="toggleCustomTemplate"
        >
            {{ $t('jobs.use_custom_auto_reply') }}
        </toggle>
        <div v-if="useCustomTemplate" class="grid grid-cols-2 gap-32 mt-16">
            <select-dropdown
                :auto-translate="false"
                v-model="selectedTemplate"
                :options="templateChoices"
                no-auto-sort
            ></select-dropdown>
        </div>
    </div>
</template>

<script>
import Toggle from '../forms/Toggle.vue';
import * as templates from '../../services/EmailTemplateService';
import EmailTemplate from '../../models/EmailTemplate';
import { normalizeJson } from '../../../shared/helpers';
import SelectDropdown from '../forms/SelectDropdown.vue';
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        'toggle': Toggle,
        'select-dropdown': SelectDropdown,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            default: null,
            validator: value => value === null || !isNaN(value),
        }
    },
    data: function () {
        return {
            useCustomTemplate: !!this.value,
            templatesLoaded: false,
            selectedTemplate: this.value,
        }
    },
    computed: {
        ...mapStores(useMainStore),
        locale() {
            return this.mainStore.locale;
        },
        templateChoices () {
            return useRepo(EmailTemplate)
                .where('type', 'auto_reply')
                .orderBy('order')
                .get()
                .map(template => ({
                    value: template.id,
                    label: template.name[this.locale]
                }));
        }
    },
    methods: {
        toggleCustomTemplate (value) {

            this.useCustomTemplate = value;

            if (value) {
                this.loadTemplates();
                return;
            }

            this.$emit('change', null);
        },
        async loadTemplates () {
            if (!this.templatesLoaded) {
                await this.fetchTemplates();
            }

            this.$emit('change', parseInt(this.selectedTemplate));
        },
        fetchTemplates () {
            return templates.index('auto_reply').then(result => {
                    return useRepo(EmailTemplate).save(normalizeJson(result.data));
                }).then(inserts => {
                    if (!this.selectedTemplate
                        || !inserts.map(template => template.id).includes(this.selectedTemplate)
                    ) {
                        this.selectedTemplate = inserts.find(template => template.default).id;
                    }

                    return this.templatesLoaded = true;
                });
        }
    },
    watch: {
        selectedTemplate (value) {
            this.$emit('change', parseInt(value));
        }
    },
    mounted () {
        if (this.useCustomTemplate) {
            this.loadTemplates();
        }
    }
}
</script>
